import { Component } from "react"
import PropTypes from "prop-types"
import { capitalize, map, omit } from "lodash"
import { Gradient } from "@mui/icons-material"
import { computeSecurityInfo } from "helpers/topics"
import { PERMISSION_LEVEL, DATE } from "helpers/shapes"
import Subnav from "components/research-topic-sub-nav"
import { getRefInstrumentResource } from "modules/research-topic/helpers"
import HelpMenu from "modules/help-menu"
import ContextualMenu from "components/contextual-menu"
import saveRecentResources from "hocs/saveRecentResources"
import { Outlet } from "react-router-dom"

import "./style.scss"

class ResearchTopicRoot extends Component {
  static propTypes = {
    topic: PropTypes.object,
    modelId: PropTypes.string.isRequired,
    modelAvailability: PropTypes.object,
    location: PropTypes.string.isRequired,
    setHeader: PropTypes.func.isRequired,
    appHeaderKey: PropTypes.string,
    setModel: PropTypes.func.isRequired,
    permissionLevel: PERMISSION_LEVEL.isRequired,
    portfolioInfo: PropTypes.object,
    portfolioDates: PropTypes.shape({
      earliest: DATE,
      latest: DATE,
    }),
    menuItems: PropTypes.array,
  }

  static getHeaderConfig({ topic, models, modelId, setModel, location, portfolioInfo, portfolioDates, menuItems }) {
    const rightActions = []
    const info = []

    if (topic) {
      info.push({
        value: topic.description,
      },
      {
        label: "Selected Date",
        value: topic.selectedDate,
      })
      if (portfolioInfo) {
        info.push({
          label: "Reference Instrument",
          values: [
            { label: "Name", value: portfolioInfo.name },
          ],
        })
      } else {
        const securityInfo = computeSecurityInfo(topic.referenceInstrument.securityId)
        info.push({
          label: "Reference Instrument",
          values: map(omit(securityInfo, "internalId"), (value, key) => ({
            label: `${capitalize(key)}:`,
            value,
          })),
        })
      }
    }

    const { id: resourceId, type: resourceType } = getRefInstrumentResource(topic)
    const menu = <ContextualMenu items={menuItems} />
    return {
      icon: Gradient,
      info,
      menu,
      title: topic ? topic.name : "Loading Research Topic...",
      overridableBy: topic && location === "smart-trade" ? `smartTrade${topic.id}` : null,
      key: topic ? `topic-${topic.name}${topic.description}${modelId}` : null,
      actions: { rightActions, help: <HelpMenu modelId={modelId} iconButton /> },
      modelId,
      subnav: modelId ? <Subnav
        modelId={modelId}
        models={models}
        setModel={setModel}
        resourceId={resourceId}
        resourceType={resourceType}
        portfolioDates={portfolioDates}
      /> : <div />,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.modelId !== this.props.modelId) {
      this.props.setModel(this.props.modelId)
    }
  }

  render() {
    const { modelId, topic, modelAvailability, setHeader, appHeaderKey, portfolioDates } = this.props
    return <div className="modules_research-topic-root">
      <div className="main">
        <div className="container-fluid">
          <Outlet context={{ modelId, currentTopic: topic, modelAvailability, setHeader, appHeaderKey, portfolioDates }} />
        </div>
      </div>
    </div>
  }
}

// Static methods must be copied over
// https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
const Enhanced = saveRecentResources(ResearchTopicRoot, "topic.id")
Enhanced.getHeaderConfig = ResearchTopicRoot.getHeaderConfig
export default Enhanced
